// extracted by mini-css-extract-plugin
export default {"container":"PP-z","title":"QP-z","link":"RP-z"};